module.exports = __webpack_public_path__ + "static/media/wallet-icon.15bb67c5.svg";